import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionLockPayload } from 'api/actions/revision-lock/revision-lock-payload';
import { RevisionLockPathParameters } from 'api/actions/revision-lock/revision-lock-path-parameters';
import { RevisionLockResponse } from 'api/actions/revision-lock/revision-lock-response';

type RevisionLockQueryParameters = Record<string, any>;

/**
 * The path of the RevisionLock action.
 */
export const revisionLockActionPath = new SweetPath<keyof RevisionLockPathParameters>(
  '/api/revision/lock/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionLock actions.
 */
export default function createRevisionLockAction(axios: AxiosInstance) {
  return function revisionLockAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionLockPathParameters;
    query?: RevisionLockQueryParameters;
    payload: RevisionLockPayload;
  }) {
    const path = revisionLockActionPath.insert(parameters);

    return axios.request<RevisionLockResponse, RevisionLockResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
